import React, { useContext } from 'react';
import { Button, IconAdd, Modal, Picker, TextField } from '@riac/design-system';
import { ControlledWLItem } from 'src/components/Wishlists/WishlistItem';
import { Item } from '@react-stately/collections';
import { WishlistActionContext } from 'src/lib/WishlistActionContext';

export const AddToWishlist = ({
  item,
  selectedList,
  wishlistSelect,
  addNew,
  saveItem,
  newItemNote,
  setNewItemNote,
  newListName,
  setNewListName,
  auctionTitle,
  closeModal,
  error,
}):JSX.Element => {
  const { currentWishlists } = useContext(WishlistActionContext);

  return (
    <Modal
      isOpen
      onClose={() => closeModal()}
      showCloseButton
      isDismissable
      title={auctionTitle}
      type='narrow'
      footerButtons={<>
        <Button onPress={saveItem} isDisabled={selectedList === '0'}>Save</Button>
      </>}
      className='min-h-64'
    >
      <p>Select a Wishlist to add the item to, or create a new wishlist.</p>
      <Picker
        label = ''
        aria-label = 'Add to Wishlist'
        placeholder = 'Add To Wishlist'
        onSelectionChange = {(value:number):void => {
          wishlistSelect(value.toString());
        }}
        selectedKey = {selectedList}
      >

        {currentWishlists?.map((wl) => (
          <Item key = {wl.WishListID}>{wl.WishListName}</Item>
        )).concat([(
          <Item key = '-1' textValue = 'New Wishlist'>
            <div className='flex flex-row gap-2 items-center'><IconAdd/> New Wishlist</div>
          </Item>
        )])}

      </Picker>
      {addNew && <>
        <h4>New Wishlist</h4>
        <TextField
          type='text'
          aria-label='Wishlist Name'
          placeholder='Enter Wishlist Name'
          value={newListName}
          onChange={(value) => setNewListName(value)}
          errorMessage={error}
        />
      </>}
      <div className='py-4'>
        <ControlledWLItem
          notes={newItemNote}
          setNotes={setNewItemNote}
          item={item}
          notesOpen={true}
          type='add'
        />
      </div>
      <Button variant='link' target={'_blank'} to={'/account/wishlist'}>View all wishlists</Button>
    </Modal>
  );
};
